import React, {useState, useEffect} from 'react';
import './Blog.css';
// import avatar1 from '../../assets/avatar1.jpg';
// import { Link, } from 'react-router-dom';
import Footer from '../../general/footer/Footer';

import img1 from "../../assets/img1.webp";
import img2 from "../../assets/img2.jpg";
import img3 from "../../assets/img3.jpg";

const Blog = () => {
            const [blogs, setBlogs] = useState([]);
            const [loading, setLoading] = useState(false);
    
const [activeCategory, setActiveCategory] = useState('All'); // default shows all blogs

                              useEffect(() => {
                                fetchBlogs();
                            }, []);
                
                
                                            const fetchBlogs = async () => {
                                    setLoading(true);
                                    try {
                                        const response = await fetch('https://api.shaktitours.com/get-blog');
                        
                                        if (response.ok) {
                                            const data = await response.json();
                                            console.log(data);
                  data.sort((a, b) => new Date(b.added_on) - new Date(a.added_on));
                  setBlogs(data);
                                            setLoading(false);
                                        } else {
                                            setLoading(false);
                                            console.error('Failed to fetch coupon');
                                        }
                                    } catch (error) {
                                        setLoading(false);
                                        console.error('Error fetching data:', error);
                                    }
                                };
                
                       const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};
         

    // const recentPosts = [
    //     {
    //         title: "Earn good money and make you very successful",
    //         date: "October 10, 2024",
    //         image: img2,
    //     },
    //     {
    //         title: "Avenue money and make you very creative work",
    //         date: "October 19, 2024",
    //         image: img3,
    //     },
    //     {
    //         title: "Earn good money and make you very successful",
    //         date: "October 29, 2024",
    //         image: img2,
    //     },
    //     {
    //         title: "Avenue money and make you very creative work",
    //         date: "April 1, 2025",
    //         image: img3,
    //     },
    //     {
    //         title: "Earn good money and make you very successful",
    //         date: "April 19, 2025",
    //         image: img2,
    //     },
    //     {
    //         title: "Avenue money and make you very creative work",
    //         date: "April 10, 2025",
    //         image: img3,
    //     },
    // ];





    return (
        <>
            <section className="blog-section">
                <div className="blog-heading">
                    <span className="blog-label">Blog</span>
                    <h2 className="blog-title">
                        Latest <span className="highlight">Blog</span> & Articles
                    </h2>
                    <p className="blog-description">
                        Our Blog and Articles Section Offers Fresh Perspectives on Investment and Business Topics,
                        with New Posts Added Regularly
                    </p>
                </div>
            </section>
            {/* <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br> */}
            {/* navbar */}
<nav className="navbar1">
  <ul className="nav-links1">
    {['All', 'Mutual Funds', 'Personal Finance', 'PMS & AIFs', 'Sector Outlook'].map((category) => (
      <li
        key={category}
        className={activeCategory === category ? 'active' : ''}
        onClick={() => setActiveCategory(category)}
        style={{ cursor: 'pointer' }}
      >
        {category}
      </li>
    ))}
  </ul>
  <input className="search-box" placeholder="Search..." />
</nav>

            {/* blog card 
            <div className='cards'>
                <div className="blog-card">
                    <img src={avatar1} alt="blog" className="blog-img" />
                    <h3>hello</h3>
                <div className="blog-card">
                    <img src={avatar1} alt="blog" className="blog-img" />
                    <h3>hello</h3>
                    <button className="read-more">Read More →</button>
                </div>>
                <div className="blog-card">
                    <img src={avatar1} alt="blog" className="blog-img" />
                    <h3>hello</h3>
                    <button className="read-more">Read More →</button>
                </div>
                <div className="blog-card">
                    <img src={avatar1} alt="blog" className="blog-img" /
                    <h3>hello</h3>
                    <button className="read-more">Read More →</button>
                </div>
                    <button className="read-more">Read More →</button>
                </div>
                <div className="blog-card">
                    <img src={avatar1} alt="blog" className="blog-img" />
                    <h3>hello</h3>
                    <button className="read-more">Read More →</button>
                </div>
            </div> */}

            {/* vlogs */}

            <div className="blog-container">
                {/* Left: Blog Content */}
                <div className="blog-left">
  {blogs
    .filter(blog => activeCategory === 'All' || blog.category === activeCategory)
    .map(blog => ( 
                                    <>
                                <img src={`https://api.shaktitours.com/pUploads/${blog.image}`} className='img-fluid mb-2' alt={`Post`} />
                                    <small className='ms-5'>📅{formatDate(blog.added_on)}</small><br />
    <span className='bg-secondary rounded text-light px-2 py-1 fw-semibold para-text'>{blog.category}</span>
                                                        <p className="blog-text">
{blog.title}</p>
{blog.description}
<hr />
                            </>
))}

                  
                </div>

                {/* Right: Sidebar */}
                <div className="blog-right">

                    <h3>Recent Posts</h3>
                    <ul className="recent-posts">


{blogs.slice(0, 6).map(blog => (                   
                                    <li>
                                <img src={`https://api.shaktitours.com/pUploads/${blog.image}`} alt={`Post`} />
                                <div>
                                    <p>{blog.title}</p>
                                    <small>📅 {formatDate(blog.added_on)}</small>
                                </div>
                            </li>
))}

                    </ul>
                </div>
            </div>




            <br></br><br></br><br></br><br></br><br></br><br></br>

            <Footer />
        </>
    )
};
export default Blog;
